import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';

setAutoFreeze(false); // 禁止凍結

const localPrefer = JSON.parse(
  sessionStorage.getItem('custom-itinerary-prefer'),
);

const initialState = {
  // 2.0項目
  country: localPrefer?.country ?? '',
  departure: localPrefer?.departure ?? '',
  day: localPrefer?.day ?? '',
  from: localPrefer?.from ?? '',
  to: localPrefer?.to ?? '',
  // 1.0項目
  travelPurpose: localPrefer?.travelPurpose ?? [],
  travelPurposeOther: localPrefer?.travelPurposeOther ?? '',
  travelStyle: localPrefer?.travelStyle ?? [],
  travelStyleOther: localPrefer?.travelStyleOther ?? '',
  pace: localPrefer?.pace ?? [0],
  pacePick: localPrefer?.pacePick ?? 0,
  daytime_from: localPrefer?.daytime_from ?? '08:00',
  daytime_to: localPrefer?.daytime_to ?? '18:00',
  note: localPrefer?.note ?? '',
};

export const preferSlice = createSlice({
  name: 'prefer',
  initialState,
  reducers: {
    preferUpdate: (state, action) => {
      sessionStorage.setItem(
        'custom-itinerary-prefer',
        JSON.stringify(action.payload),
      );
      return action.payload;
    },
    preferReset: () => {
      sessionStorage.removeItem('custom-itinerary-prefer');
      return {
        country: '',
        departure: '',
        day: '',
        from: '',
        to: '',
        travelPurpose: [],
        travelPurposeOther: '',
        travelStyle: [],
        travelStyleOther: '',
        pace: [0],
        pacePick: 0,
        daytime_from: '08:00',
        daytime_to: '18:00',
        note: '',
      };
    },
  },
});

export const preferSelect = (state) => state.prefer;
export const { preferUpdate, preferReset } = preferSlice.actions;
export default preferSlice.reducer;
